import { string } from "prop-types";
import React from "react";
import { twMerge } from "tailwind-merge";

const InfoIcon = ({ className }) => (
  <span
    className={twMerge(
      "block relative size-5 bg-current rounded-full",
      "before:content-[''] before:block before:bg-current before:text-white before:w-[12%] before:h-[45%] before:absolute before:left-1/2 before:bottom-[18%] before:-translate-x-1/2",
      "after:content-[''] after:block after:bg-current after:text-white after:size-[12%] after:absolute after:left-1/2 after:top-[18%] after:-translate-x-1/2",
      className
    )}
  />
);

InfoIcon.propTypes = {
  className: string,
};

export default InfoIcon;
